import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks/useTypedQuery";

import type { StatusFilter } from "components";
import type { Appointment, Car, Customer } from "models";
import type { SpecialIndicatorData } from "modules/Appointments/hooks";

type LessorROBDataResponse = {
  code: string;
  number: number;
  name: string;
  address: {
    street: string;
    streetNumber: string;
    postalCode: string;
    city: string;
  };
  contact: string;
  phone: {
    general: string;
  };
  subLessors: [];
};

type ContractROBDataResponse = {
  leaseContract: Record<string, any>;
  supplierContract: Record<string, any>;
  lessor: {
    number: number;
    name: string;
    subLessorCode: string;
  };
  vehicle: {
    vehicleMake: string;
    vehicleModel: string;
  };
};

export type SelectedDatesData = {
  startDate: string;
  endDate: string | null;
};

export type CartIndicatorType = {
  is_shop?: string;
  is_shop_green?: string;
  is_shop_orange?: string;
  is_shop_blue?: string;
  is_shop_yellow?: string;
  is_shop_red?: string;
};

export type StarIndicatorType = {
  is_star?: string;
  is_star_red?: string;
  is_star_blue?: string;
  is_star_yellow?: string;
  is_star_green?: string;
};

const component = "Appointments";

export const AppointmentsQueryKeys = {
  carMakesOptions: localQueryKey<string[]>({ component, data: "carMakesOptions" }),
  carMakesToFilter: localQueryKey<string[]>({ component, data: "carMakesToFilter" }),
  selectedDateToList: localQueryKey<string>({ component, data: "selectedDateToList" }),
  selectedDatesToList: localQueryKey<SelectedDatesData>({ component, data: "selectedDatesToList" }),
  cartIndicatorsToFilter: localQueryKey<CartIndicatorType>({ component, data: "cartIndicatorsToFilter" }),
  starIndicatorsToFilter: localQueryKey<StarIndicatorType>({ component, data: "starIndicatorsToFilter" }),
  specialIndicatorsToFilter: localQueryKey<SpecialIndicatorData>({ component, data: "specialIndicatorsToFilter" }),
  selectedIdentifiersToFilter: localQueryKey<StatusFilter[]>({ component, data: "selectedIdentifiersToFilter" }),
  searchCars: backendQueryKey<Car[]>({ component, baseUrl: ENV.carBaseURL, endpoint: "/cars/search/regnr" }),
  list: backendQueryKey<Appointment[]>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/appointments/list_daily" }),
  searchCustomersByCar: backendQueryKey<Customer[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/customers/list_by_car" }),
  woNumber: backendQueryKey<string>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/locations/appointment/generate_wonr" }),
  lessorROBData: backendQueryKey<LessorROBDataResponse>({ component, baseUrl: ENV.carBaseURL, endpoint: "/robnet/get_lessor_by_regnr" }),
  contractROBData: backendQueryKey<ContractROBDataResponse>({ component, baseUrl: ENV.carBaseURL, endpoint: "/robnet/get_contract_by_regnr" })
};
